// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import devopsLoginServer from './loginServer';

/** 获取当前的用户 GET /api/currentUser */
// export async function getTokenInfo(path: string) {
//   return request<API.ImileResponse<any>>('/indexBack?' + path, {
//     method: 'GET',
//   });
// }

// 登录
export function getTokenInfo(data: any) {
  return devopsLoginServer.post('/indexBack', data);
}

// 刷新token
export function refreshToken(userCode: string, refreshToken: any) {
  return devopsLoginServer.get('/refresh-token', {
    params: { userCode, refreshToken },
  });
}

// 退出登录
export function logout(userCode: string) {
  return devopsLoginServer.get('/logout', {
    params: { userCode },
  });
}



/** 获取 数据字典**/
export async function getDictData(typeCode: string) {
  return request<API.ImileResponse<any>>('/system/dict/data/options?typeCode=' + typeCode, {
    method: 'GET',
  });
}

/** 获取当前的用户 GET /getInfo */
export async function currentUser(options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/getInfo', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取全部用户 */
export async function listUsers(options?: { [key: string]: any }) {
  return request<API.UserOption[]>('/system/user/selectList', {
    method: 'POST',
    ...(options || {}),
  });
}
/** 获取业务领域下的用户信息 */
export async function mapDeptUserInfoByBusinessCodes(options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/base/business/map-dept-user-info-by-business-codes', {
    method: 'POST',
    ...(options || {}),
  });
}
/** 登录人员下拉列表 */
export async function selectLoginList() {
  return request<API.ImileResponse<any>>('/system/user/selectLoginList', {
    method: 'GET',
  });
}

/** 根据角色获取用户 */
export async function listUsersByRoleKey(roleKey: any, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/system/user/selectListByRoleKey?roleKey=' + roleKey, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取不分页系统 */
export async function listChangeSystem(params?: any, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>(
    `/issue/systemList${
      params?.isQueryDbNames !== undefined ? `?isQueryDbNames=${params.isQueryDbNames}` : ''
    }`,
    {
      data: params,
      method: 'POST',
      ...(options || {}),
    },
  );
}

/** 获取值班人 */
export async function listSchedulingUser(body: Object, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/release/scheduling/list', {
    data: body,
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取用户系统缓存 */
export async function getUserSystemCache(options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/base/system/get-user-system-cache', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 设置用户系统缓存 */
export async function setUserSystemCache(systemId: string, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>(
    '/base/system/set-user-system-cache?systemId=' + systemId,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 通用 Redis 缓存写入 */
export async function addCommonCache(key: string, value: string, timeout: number, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/cache/add', {
    method: 'POST',
    data: { key, value, timeout },
    ...(options || {}),
  });
}

/** 通用 Redis 缓存读取 */
export async function getCommonCacheValue(key: string, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/cache/getValue', {
    method: 'POST',
    data: { key },
    ...(options || {}),
  });
}

/** 通用 Redis 缓存删除 */
export async function deleteCommonCache(key: string, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/cache/delete', {
    method: 'POST',
    data: { key },
    ...(options || {}),
  });
}

/** 上传文件 */
export async function uploadFile(body: Object, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/oss/upload', {
    data: body,
    method: 'POST',
    ...(options || {}),
  });
}

/** 下载文件 */
export async function downloadFile(body: Object, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/oss/download', {
    data: body,
    method: 'POST',
    responseType: 'blob',
    ...(options || {}),
  });
}


export async function pagedNoticeMsg(params: any, options?: { [key: string]: any }) {
  return request<API.ImileResponse<API.NoticeIconList>>('/sys-notice-message/paged-msg', {
    data: {
      currentPage: params.current,
      showCount: params.pageSize,
      ...params,
    },
    method: 'POST',
    ...(options || {}),
  });
}
export async function getNoticesNotReadCount(options?: { [key: string]: any }) {
  return request<API.ImileResponse<number>>('/sys-notice-message/get-not-read-count', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getNoticesTypeCount(options?: { [key: string]: any }) {
  return request<API.ImileResponse<number>>('/sys-notice-message/get-type-count', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function readById(id: any, options?: { [key: string]: any }) {
  return request<API.ImileResponse<number>>('/sys-notice-message/read?id=' + id, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function readAll(options?: { [key: string]: any }) {
  return request<API.ImileResponse<number>>('/sys-notice-message/read-all', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function delById(id: any, options?: { [key: string]: any }) {
  return request<API.ImileResponse<number>>('/sys-notice-message/del-by-id?id=' + id, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 根据角色查询人 */
export async function listUserByType(executorType: string) {
  return request<API.ImileResponse<any>>(
    '/issue-executor/list-by-type?executorType=' + executorType,
    {
      method: 'GET',
    },
  );
}

/** 根据角色查询人 */
export async function groupUserByType() {
  return request<API.ImileResponse<any>>('/issue-executor/group-by-type', {
    method: 'GET',
  });
}

/** 查询数据字典状态*/
export async function listProgress(body: any, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/progress-config/list-progress', {
    data: body,
    method: 'POST',
    ...(options || {}),
  });
}

/** 查询筛选条件 */
export async function getFilterContent(type: string) {
  return request<API.ImileResponse<API.FilterDetail>>(
    '/user-filter/get-filter-content?type=' + type,
    {
      method: 'GET',
    },
  );
}

/** 保存或更新筛选条件*/
export async function createOrUpdFilter(body: any, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/user-filter/create-or-upd-filter', {
    data: body,
    method: 'POST',
    ...(options || {}),
  });
}

/** 保存备注(无消息通知版) */
export async function saveRemark(param) {
  return request('/common-remark/save', {
    data: param,
    method: 'POST',
  });
}

/** 添加备注(会有消息通知) */
export async function addNoticeRemark(param) {
  return request('/common-remark/add-remark', {
    data: param,
    method: 'POST',
  });
}

/** 查询备注 */
export async function listRemark(param) {
  return request('/common-remark/list', {
    data: param,
    method: 'POST',
  });
}

/** 查询指定工作项的备注 */
export async function getWorkItemRemark(relatedType: string, relateId: string) {
  return request('/common-remark/get-work-item-remark', {
    params: { relatedType, relateId },
    method: 'GET',
  });
}

/**
 * 通用执行人：手动添加 / 移除指定角色人员（如项目团队成员）
 */
export interface CommonAddAndRemoveRoleUserParam {
  /** 关联类型，例如 PROJECT、ISSUE 等，由后端约定 */
  relatedType: string;
  /** 关联 ID，如项目 ID、需求 ID */
  relatedId: string;
  /** 执行者类型（角色标识），由后端约定 */
  executorType: string;
  /** 执行者人员编码列表 */
  executorCodes: string[];
}

/** 手动添加指定角色人员 */
export async function addRoleUser(data: CommonAddAndRemoveRoleUserParam, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/common-executor/role-add', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 手动移除指定角色人员 */
export async function removeRoleUser(data: CommonAddAndRemoveRoleUserParam, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/common-executor/remove-add', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 删除备注 */
export async function deleteRemark(id: string) {
  return request('/common-remark/delete', {
    params: { id },
    method: 'GET',
  });
}

/** 添加阅读记录 */
export async function addRead(param) {
  return request('/common-read/add', {
    data: param,
    method: 'POST',
  });
}

/** 获取阅读情况 */
export async function getReadSituation(relateType, relateId) {
  return request('/common-read/read-situation?relateType=' + relateType + '&relateId=' + relateId, {
    method: 'GET',
  });
}

/** 获取点赞情况 */
export async function getLikeSituation(relateType: string, relateId: string) {
  return request('/common-like/like-situation?relateType=' + relateType + '&relateId=' + relateId, {
    method: 'GET',
  });
}

/** 添加点赞 */
export async function addLike(param: any) {
  return request('/common-like/add', {
    data: param,
    method: 'POST',
  });
}

/** 取消点赞 */
export async function cancelLike(param: any) {
  return request('/common-like/cancel', {
    data: param,
    method: 'POST',
  });
}

/** 添加评论 */
export async function addComment(param) {
  return request('/common-comment/add', {
    data: param,
    method: 'POST',
  });
}

/** 删除评论 */
export async function deleteComment(id) {
  return request('/common-comment/delete?id=' + id, {
    method: 'GET',
  });
}

/** 获取评论树 */
export async function getCommentsTree(relateType, relateId) {
  return request(
    '/common-comment/get-comments-tree?relateType=' + relateType + '&relateId=' + relateId,
    {
      method: 'GET',
    },
  );
}

/** 获取部门列表 */
export async function listDept() {
  return request('/user-info/list-dept', {
    method: 'GET',
  });
}

/** 获取部门下拉树 */
export async function listDeptTree() {
  return request('/user-info/dept-tree', {
    method: 'GET',
  });
}

/** 获取部门成员列表 */
export async function listDeptUser(deptId: string) {
  return request('/user-info/list-dept-user?deptId=' + deptId, {
    method: 'GET',
  });
}
export async function listDeptUserByDeptIds(params: any) {
  return request('/user-info/list-flat-user-by-dept-ids', {
    data: params,
    method: 'POST',
  });
}

/** 通用驳回操作 */
export async function commonReject(param: any) {
  return request('/common-reject', {
    data: param,
    method: 'POST',
  });
}

/** 获取驳回物料信息 */
export async function getRejectMaterial(nodeType: string, nodeCode: string) {
  return request('/common-reject/get-material?nodeType=' + nodeType + '&nodeCode=' + nodeCode, {
    method: 'GET',
  });
}

/** 获取服务的所有域名 */
export async function getDomainByServiceName(serviceName: string) {
  return request('/mse-gateway-domain/list-domain-by-service-name?serviceName=' + serviceName, {
    method: 'GET',
  });
}

/** 获取国家列表 */
export async function getCountryList() {
  return request('/hermes-biz-zone-info/list-select-biz-zone-country', {
    method: 'GET',
  });
}

/** 进群 */
export async function joinBug(bugId: string) {
  return request('/bug-record/add-group?bugId=' + bugId, {
    method: 'GET',
  });
}

/** 是否为CTO角色或者为业务领域负责人或者业务领域主产品经理 */
export async function isCtoOrBusinessLeaderOrMainManager() {
  return request('/user-permission/business-leader-or-main-manager', {
    method: 'GET',
  });
}

/** 添加责任人 */
export async function addResponsibility(param: any) {
  return request('/responsibility/add', {
    data: param,
    method: 'POST',
  });
}

/** 查看责任人详情 */
export async function detailResponsibility(relatedType: string, relatedId: string) {
  return request('/responsibility/detail?relatedType=' + relatedType + '&relatedId=' + relatedId, {
    method: 'GET',
  });
}

// 分页查询审批记录
// export async function pageApprovalRecord(params: any, options?: { [key: string]: any }) {
//   return request('/common-approval/page', {
//     data: {
//       currentPage: params.current,
//       showCount: params.pageSize,
//       ...params,
//     },
//     method: 'POST',
//     ...(options || {}),
//   });
// }


/** 创建或更新文档 */
export async function createOrUpdateDoc(param: any) {
  return request('/common-document/create-or-update', {
    data: param,
    method: 'POST',
  });
}

/** 获取文档详情 */
export async function getDocDetail(relatedType: string, relatedId: string) {
  return request('/common-document/detail?relatedType=' + relatedType + '&relatedId=' + relatedId, {
    method: 'GET',
  });
}


/** 通用添加关联绑定 */
export async function commonBinds(
  param: {
    relatedType: string;
    relatedId: string;
    bindType: string;
    bindIds: string[];
  }
) {
  return request('/common-bind/add', {
    data: param,
    method: 'POST',
  });
}

/** 通用关联解绑 */
export async function removeBinds(
  param: {
    relatedType: string;
    relatedId: string;
    bindType: string;
    bindIds: string[];
  }
) {
  return request('/common-bind/remove', {
    data: param,
    method: 'POST',
  });
}


/** 通用修改关联绑定 */
export async function commonUpdateBinds(
  param: {
    relatedType: string;
    relatedId: string;
     bindType: string;
    bindIds: string[];
  }
) {
  return request('/common-bind/update', {
    data: param,
    method: 'POST',
  });
}

/** 通用查询关联产品需求 */
export async function relatedProductIssues(param: { relatedType: string; relatedId: string | number }) {
  return request<API.ImileResponse<any>>('/common-bind/related-product-issues', {
    method: 'POST',
    data: param,
  });
}

/**通过ids获取点赞记录 */
export async function getLikeInfosByIds(body: string[], options?: { [key: string]: any }) {
  return request('/common-like/infos-by-ids', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

